import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import Header from "../Header";
import { Footer } from "../Footer";

export const Layout: React.FC = () => {
  return (
    <Box bg="#F7F9FF" pt={30} flex={1}>
      <Box
        as="header"
        position="fixed"
        top="0"
        left="0"
        right="0"
        zIndex="1000"
        bg="white"
        boxShadow="sm"

      >
        <Header />
      </Box>

      <Box as="main" pt="120px">
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </Box>

      <Footer />
    </Box>
  );
};
